export function isValidCNPJ(cnpj: string): boolean {
  if (!cnpj) return false;
  const cleanedCnpj = cnpj.replace(/[^\d]/g, '');

  const CNPJ_LENGTH = 14;
  if (cleanedCnpj.length !== CNPJ_LENGTH) {
    return false;
  }

  const allDigitsTheSame = new RegExp(`^(\\d)\\1{${CNPJ_LENGTH - 1}}$`);
  if (allDigitsTheSame.test(cleanedCnpj)) {
    return false;
  }

  const digits = cleanedCnpj.split('').map(Number);
  const firstVerifierDigit = digits[12];
  const secondVerifierDigit = digits[13];

  const firstDigitFactors = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const secondDigitFactors = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  const calculatedFirstDigit = calculateVerifierDigit(
    digits.slice(0, 12),
    firstDigitFactors,
  );
  if (calculatedFirstDigit !== firstVerifierDigit) {
    return false;
  }

  const calculatedSecondDigit = calculateVerifierDigit(
    digits.slice(0, 13),
    secondDigitFactors,
  );
  if (calculatedSecondDigit !== secondVerifierDigit) {
    return false;
  }

  return true;
}

function calculateVerifierDigit(digits: number[], factors: number[]): number {
  const sum = digits.reduce((acc, digit, index) => {
    return acc + digit * factors[index];
  }, 0);

  const remainder = sum % 11;

  return remainder < 2 ? 0 : 11 - remainder;
}
